import React from "react";
import { useNavigate } from "react-router-dom";
import MainButton from "../MainButton/MainButton";
import LeftArrowIcon from "../../assets/svgs/left-arrow.svg";
import RightArrowIcon from "../../assets/svgs/right-arrow.svg";
import ArrowCircleIcon from "../../assets/svgs/arrow-circle.svg";
import styles from "./CustomToolbar.module.css";

const CustomToolbar = ({ label, onNavigate, isAdmin }) => {
  const navigate = useNavigate();

  const handleAdminClick = () => {
    navigate("/admin");
  };


  return (
    <div className={styles.toolbar}>
      <span className={styles.navigation}>
        <span
          className={`${styles.navArrowWrapper} ${styles.leftArrowWrapper}`}
          onClick={() => onNavigate("PREV")}
        >
          <img src={LeftArrowIcon} alt="Mes anterior" className={`${styles.navArrow} ${styles.leftArrow}`} />
        </span>
        <span className={styles.toolbarLabel}>{label}</span>
        <span
          className={`${styles.navArrowWrapper} ${styles.rightArrowWrapper}`}
          onClick={() => onNavigate("NEXT")}
        >
          <img src={RightArrowIcon} alt="Mes siguiente" className={`${styles.navArrow} ${styles.rightArrow}`} />
        </span>
      </span>

      {isAdmin && (
        <span className={styles.viewButtons}>
          <MainButton
            variant="dark"
            onClick={handleAdminClick}
            rightIcon={ArrowCircleIcon}
            rightIconAlt="Cambiar a admin"
          >
            Cambiar a admin
          </MainButton>
        </span>
      )}
    </div>
  );
};

export default CustomToolbar;
